/**
 * Base class for the extensions of `ui5-table` components.
 * @private
 */
export default abstract class TableExtension {}
